export const scrollStore = {
  lenis: null,
  scrollTo(target, opts = {}) {
    if (this.lenis) {
      this.lenis.scrollTo(target, { duration: 1.8, ...opts });
    } else if (typeof target === "number") {
      window.scrollTo(0, target);
    } else {
      document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    }
  },
};
